/**
 * OoKey 公式ロゴ (2026-05-26 改訂: ユーザー指定の最新版)。
 *
 * シンボル: 外側のハロー円 (r=13) + 鍵頭 (cx=12.64, cy=19.36, r=4) + 右上の魔法の杖。
 * viewBox 0 0 32 32, stroke-width 1.3, stroke は currentColor (CSS の `color:` で切替可)。
 *
 * 既定色は `.ookey-logo` CSS の `color: var(--ookey-orange-light)` (#e07c4a)。
 * 寸法は `size` prop (px) で指定。default 32。
 */
export interface OokeyLogoProps {
  /** logo の寸法 (px)。default 32。Sidenav は 44 を渡している。 */
  size?: number
  /**
   * @deprecated 旧 API 互換。内部で size として扱う。
   */
  width?: number
}

export const OokeyLogo = ({ size, width }: OokeyLogoProps = {}): JSX.Element => {
  const dim = size ?? width ?? 32

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width={dim}
      height={dim}
      fill="none"
      className="ookey-logo"
      role="img"
      aria-label="OoKey"
    >
      <circle cx={16} cy={16} r={13} stroke="currentColor" strokeWidth={1.3} />
      <circle cx={12.64} cy={19.36} r={4} stroke="currentColor" strokeWidth={1.3} />
      <path
        d="M25.15 6.85L15.38 16.62M23 9L24.5 10.5M21 11L22.5 12.5"
        stroke="currentColor"
        strokeWidth={1.3}
        strokeLinecap="butt"
      />
    </svg>
  )
}
